<!-- <div class="scroll-wrapper">
  <div class="scroll-inner no-scrollbar"> -->
<div class="leads-view-root">
  <!-- Main content -->
  <main class="main-wrapper" [class.menu-expanded]="isMenuExpanded">
    <div class="main-content" [class.menu-expanded]="isMenuExpanded">
      <!-- Loading state -->
      @if (loading) {
      <div class="loading-container">
        <div class="loading">Loading lead details...</div>
      </div>
      }

      <!-- Error state -->
      @if (error && !loading) {
      <app-entity-load-error-state kind="lead" (back)="goToLeads()" />
      }

      <!-- Lead details content -->
      @if (!error && !loading && currentLead) {

      <!-- Section 1: Header -->
      <div class="lead-header-section">
        <div class="lead-header-row">
          <div class="lead-header-info">
            <div class="breadcrumbs-container">
              <aio-breadcrumbs [items]="leadBreadcrumbs"
                (itemClick)="onBreadcrumbClick($event)" separatorIcon="chevron-right"></aio-breadcrumbs>
            </div>
            <div class="lead-header-details">
              <div class="back-btn">
                <img src="assets/icons/chevron_left.svg" alt="Back" class="back-arrow clickable icon-sm"
                  (click)="goToLeads()">
              </div>
              <div class="lead-header-content">
                <span class="lead-header-name">{{ currentLead.title }}</span>
                @if (currentLead.isArchived) {
                <div class="opportunity-status ARCHIVED" aria-label="Lead archived">
                  <span class="status-label">Archived</span>
                </div>
                }
              </div>
            </div>
          </div>
          <div class="lead-header-actions">
            <div class="button-group">
              <aio-button
                appearance="neutral-stroke"
                size="sm"
                class="archive-btn"
                iconSrc="assets/icons/archive.svg"
                [disabled]="isEditingLeadDetails || currentLead.isArchived || !hasLeadsArchivePermission()"
                (pressed)="archiveLead()">
                Archive
              </aio-button>
              <aio-button
                appearance="primary"
                size="sm"
                [block]="true"
                class="convert-btn"
                [disabled]="isEditingLeadDetails || !hasConvertToOpportunityPermission()"
                (pressed)="openConvertConfirmationModal()">
                Convert to Opportunity
              </aio-button>
              <aio-button
                appearance="ghost"
                size="sm"
                class="flag-btn"
                [iconSrc]="isFlagged ? 'assets/icons/goldFlag.svg' : 'assets/icons/outlineFlag.svg'"
                [disabled]="isEditingLeadDetails || !hasLeadsAddEditPermission()"
                [attr.title]="isFlagged ? 'Remove Flag' : 'Add Flag'"
                [ariaLabel]="isFlagged ? 'Remove Flag' : 'Add Flag'"
                (pressed)="toggleFlag()" />
            </div>
          </div>
        </div>
      </div>
      <!-- Section 2: Main Content Area (Lead Overview Left + Lead Details/Contact/Activity Right) -->
      <div class="main-content-area">
        <!-- Cards and Side Panel Grid Layout -->
        <div class="cards-panel-grid">
          <!-- Left Column: Lead Overview Card (Full Height) -->
          <div class="overview-column">
            <div class="card-wrapper overview-card-wrapper full-height-overview">
              <app-lead-overview-card [lead]="currentLead!" [projectTypes]="projectTypes" [users]="users"
                [leadOrigins]="leadOrigins" [referralChannels]="referralChannels" [labelTags]="labelTags"
                [temperatureTypes]="temperatureTypes" [customAttributeDefinitions]="customAttributeDefinitions"
                (editClick)="onCardEditClick('overview')" (expandClick)="onCardExpandClick('overview')"
                (saveClick)="onCardSaveClick($event)" (cancelClick)="onCardCancelClick()">
              </app-lead-overview-card>
            </div>
          </div>

          <!-- Right Column: Lead Details, Contact Information, and Activity Panel -->
          <div class="right-column">
            <!-- Top Row: Lead Details and Contact Information Side by Side -->
            <div class="top-cards-row">
              <!-- Lead Details Card -->
              <div class="card-wrapper">
                <app-lead-details-card [lead]="currentLead!" [leadOrigins]="leadOrigins"
                  [referralChannels]="referralChannels" [labelTags]="labelTags"
                  [customAttributeDefinitions]="customAttributeDefinitions" (editClick)="onCardEditClick('details')"
                  (expandClick)="onCardExpandClick('details')" (saveClick)="onCardSaveClick($event)"
                  (cancelClick)="onCardCancelClick()">
                </app-lead-details-card>
              </div>

              <!-- Contact Information Card -->
              <div class="card-wrapper">
                <app-contact-information-card [lead]="currentLead!" (editClick)="onCardEditClick('contact')"
                  (expandClick)="onCardExpandClick('contact')" (saveClick)="onCardSaveClick($event)"
                  (cancelClick)="onCardCancelClick()">
                </app-contact-information-card>
              </div>
            </div>

            <!-- Bottom: Side Panel Section (card wrapper to match Lead Details / Contact cards) -->
            <div class="lead-details-section">
              <div class="card-wrapper tabs-panel-card-wrapper">
                <div class="side-panel entity-context-panel-tabs" [class.menu-expanded]="isMenuExpanded">
                <app-tabs [tabs]="tabs" [selectedTab]="selectedTab" [isMenuExpanded]="isMenuExpanded"
                  [searchValue]="selectedTab === 'activity' ? activitySearchTerm : (selectedTab === 'notes' ? notesSearchTerm : (selectedTab === 'documents' ? documentsSearchTerm : (selectedTab === 'history' ? historySearchTerm : '')))"
                  [searchPlaceholder]="selectedTab === 'notes' ? 'Search notes' : (selectedTab === 'documents' ? 'Search files' : (selectedTab === 'history' ? 'Search history' : 'Search activities'))"
                  [showSearchBar]="(showActivitySearchBar && selectedTab === 'activity') || (showNotesSearchBar && selectedTab === 'notes') || (showDocumentsSearchBar && selectedTab === 'documents') || (showHistorySearchBar && selectedTab === 'history')"
                  (tabSelected)="onTabSelected($event)" (menuToggle)="onMenuToggle($event)"
                  (searchToggle)="onSearchToggle()" (searchClose)="onSearchClose()"
                  (searchValueChange)="selectedTab === 'activity' ? onActivitySearchChange($event) : (selectedTab === 'notes' ? onNotesSearchChange($event) : (selectedTab === 'documents' ? onDocumentsSearchChange($event) : (selectedTab === 'history' ? onHistorySearchChange($event) : null)))">

                  <!-- Activity Tab Content -->
                  @if (selectedTab === 'activity') {
                  <div class="tab-content">
                    <app-activity #activityRef
                      [data]="{ entityId: currentLead?.leadId || currentLeadId || 0, entityType: 'LEAD' }"
                      [searchTerm]="activitySearchTerm"
                      [initialDate]="activityInitialDate"
                      [initialEditScheduleId]="activityInitialEditScheduleId"
                      [leadAddress]="getLeadAddressForActivity()">
                    </app-activity>
                  </div>
                  }

                  <!-- Notes Tab Content -->
                  @if (selectedTab === 'notes') {
                  <div class="tab-content">
                    <app-notes [entityId]="currentLead?.leadId || currentLeadId || 0" [disabled]="!hasNotesPermission()"
                      [entityTypeId]="'LEAD'" [searchTerm]="notesSearchTerm">
                    </app-notes>
                  </div>
                  }

                  <!-- Files Tab Content -->
                  @if (selectedTab === 'documents') {
                  <div class="tab-content">
                    <app-leads-documents-tab [entityId]="currentLead?.leadId || currentLeadId"
                      [disabled]="!hasDocumentsPermission()" [entityRootFolder]="currentLead?.entityRootFolder"
                      [searchTerm]="documentsSearchTerm">
                    </app-leads-documents-tab>
                  </div>
                  }

                  <!-- History Tab Content -->
                  @if (selectedTab === 'history') {
                  <div class="tab-content">
                    <app-leads-history-tab [leadId]="currentLead?.leadId || currentLeadId" [searchTerm]="historySearchTerm">
                    </app-leads-history-tab>
                  </div>
                  }
                </app-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      }
    </div>



  </main>

  <!-- Not sure if we will need this fab button -->
  <!-- @if (shouldShowFAB()) {
        <app-floating-action-button
          [disabled]="selectedTab === 'notes'
            ? !hasNotesPermission()
            : selectedTab === 'documents'
              ? !hasDocumentsPermission()
              : !hasLeadsScheduleCreatePermission()"
          [isLoading]="loading"
          [icon]="getFABIcon()"
          (onClick)="onFloatingButtonClick()">
        </app-floating-action-button>
      } -->

  <!-- Convert to Opportunity Confirmation Modal -->
  <app-confirmation-modal [config]="convertConfirmationConfig" [isOpen]="showConvertConfirmationModal"
    (confirm)="onConvertConfirm()" (cancel)="onConvertCancel()" (close)="closeConvertConfirmationModal()">
  </app-confirmation-modal>

  <!-- Delete Participant Confirmation Modal -->
  <app-confirmation-modal [config]="deleteModalConfig" [isOpen]="showDeleteModal"
    (confirm)="onDeleteParticipantConfirm()" (cancel)="onDeleteParticipantCancel()"
    (close)="onDeleteParticipantCancel()">
  </app-confirmation-modal>

  <!-- Delete Lead Confirmation Modal -->
  <app-confirmation-modal [config]="deleteLeadModalConfig" [isOpen]="showDeleteLeadModal"
    (confirm)="onDeleteLeadConfirm()" (cancel)="onDeleteLeadCancel()" (close)="onDeleteLeadCancel()">
  </app-confirmation-modal>

  <!-- Discard Changes Confirmation Modal -->
  <app-confirmation-modal [config]="discardChangesModalConfig" [isOpen]="isDiscardModalOpen"
    (confirm)="onDiscardConfirm()" (cancel)="onDiscardCancel()" (close)="onDiscardCancel()">
  </app-confirmation-modal>

  <!-- Archive Confirmation Modal -->
  <app-confirmation-modal [config]="archiveModalConfig" [isOpen]="isArchiveModalOpen"
    (confirm)="onArchiveModalConfirm($event)" (cancel)="onArchiveModalCancel($event)"
    (close)="onArchiveModalCancel($event)">
  </app-confirmation-modal>

  <!-- Custom Label Modal -->
  <app-custom-label-modal [isOpen]="showCustomLabelModal" [loading]="creatingLabel"
    (saveLabel)="onSaveCustomLabel($event)" (cancel)="onCancelCustomLabel()">
  </app-custom-label-modal>


</div>
<!-- </div>
</div> -->